module.exports = require('./dist/style')



//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-jsx/style.js
// module id = 528
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15